"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _map2 = _interopRequireDefault(require("lodash/map"));

var _sum2 = _interopRequireDefault(require("lodash/sum"));

var _join2 = _interopRequireDefault(require("lodash/join"));

var _Kochava = _interopRequireDefault(require("../Kochava"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable @typescript-eslint/camelcase */


var serviceMethods = {
  1: 'pick-up',
  2: 'drive-thru',
  3: 'dine-in',
  4: 'delivery'
};

var transaction = function transaction(order) {
  var names = (0, _map2["default"])(order.cart, function (item) {
    return item.itemId;
  });
  var quantities = (0, _map2["default"])(order.cart, function (item) {
    return item.quantity;
  });
  var prices = (0, _map2["default"])(order.cart, function (item) {
    return item.price / item.quantity;
  });

  _Kochava["default"].activity('purchase', {
    store_number: order.storeNumber,
    order_id: order.orderId,
    pickup_type: serviceMethods[order.serviceMethod] || serviceMethods[1],
    pickup_time: order.pickupTime,
    name: (0, _join2["default"])(names, '|'),
    quantity: (0, _join2["default"])(quantities, '|'),
    item_price: (0, _join2["default"])(prices, '|'),
    quantity_sum: (0, _sum2["default"])(quantities),
    sum: order.sum
  });
};

var _default = transaction;
exports["default"] = _default;